








































































































import { deleteStudent } from "@/api/classManagement";
import { subjectRelatecourse } from "@/api/course";
import {
  createSubject,
  editSubjectTitle,
  editSubjectStatus,
  subjectList,
  subjectSettingList,
  deleteSubject,
} from "@/api/subject";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  dialogVisible: boolean = false;
  dialogTab: number = 1;
  isAdding: boolean = false;
  newSubjectTitle: string = "";
  newSubjectStatus: boolean = false;
  officalList: any[] = [];
  ownList: any[] = [];
  page: number = 0;
  created() {
    this.init();
  }
  init() {
    this.isAdding = false;
    this.newSubjectTitle = "";
    this.newSubjectStatus = false;
    subjectSettingList().then((res: any) => {
      res.data.org_subject.map((item: any) => {
        item.editing = false;
        item.subject_status = item.subject_status === 1;
      });
      res.data.system_subject.map((item: any) => {
        item.subject_status = item.subject_status === 1;
      });
      this.ownList = res.data.org_subject;
      this.officalList = res.data.system_subject;
    });
  }
  handleChangeStatus(item: any, index: number) {
    editSubjectStatus({
      subject_id: item.subject_id,
      status: item.subject_status ? 1 : 2,
    })
      .then((res: any) => {
        this.init();
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.$emit("change");
        } else {
          this.$message({
            type: "error",
            message: "修改失败!" + res.message,
          });
        }
      })
      .catch(() => {
        if (this.dialogTab === 1) {
          this.officalList[index].subject_status =
            !this.officalList[index].subject_status;
        }
        if (this.dialogTab === 2) {
          this.ownList[index].subject_status =
            !this.ownList[index].subject_status;
        }
      });
  }
  handleDialogOpen() {
    this.dialogVisible = true;
  }
  toogleShowAdding() {
    this.isAdding = !this.isAdding;
  }
  saveAdding() {
    if (this.newSubjectTitle)
      createSubject({
        title: this.newSubjectTitle,
        status: this.newSubjectStatus ? 1 : 2,
      }).then((res: any) => {
        this.init();
        if (res.error_code == 0) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.toogleShowAdding();
          this.$emit("change");
        } else {
          this.$message({
            type: "error",
            message: "添加失败!" + res.message,
          });
        }
      });
  }
  showEditing(index: number, id: number) {
    this.ownList[index].editing = true;
  }
  saveEditing(item: any) {
    editSubjectTitle({
      subject_id: item.subject_id,
      title: item.subject_title,
    }).then((res: any) => {
      this.init();
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "编辑成功!",
        });
        this.$emit("change");
      } else {
        this.$message({
          type: "error",
          message: "编辑失败!" + res.message,
        });
      }
    });
  }
  handleDelete(item: any) {
    subjectRelatecourse({
      subject_id: item.subject_id,
    }).then((result: any) => {
      if (result.error_code == 0) {
        if (result.data.list.length > 0) {
          const courseStr: string[] = [];
          result.data.list.map((c: any) => {
            courseStr.push(c.title);
          });
          this.$alert(
            `修改以下课程中的科目，才能删除：${courseStr.join(",")}`,
            `删除 - ${item.subject_title}`,
            {
              type: "warning",
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          );
        } else {
          this.$confirm("确定删除？", `删除 - ${item.subject_title}`, {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            iconClass: "mwow-icon-error",
          })
            .then(() => {
              deleteSubject({ subject_id: item.subject_id }).then(
                (res: any) => {
                  if (res.error_code == 0) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.init();
                    this.$emit("change");
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败：" + res.message,
                    });
                  }
                }
              );
            })
            .catch(() => {});
        }
      }
    });
  }
}
